module.exports = __webpack_public_path__ + "static/media/obj-1.eb929b7c.svg";